var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_987_12262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 9.70704C0 15.0592 4.39714 19.414 9.80145 19.414C11.9386 19.414 13.8915 18.7329 15.5005 17.5894L21.5435 23.5863C21.826 23.8662 22.1945 24 22.5876 24C23.4227 24 24 23.3796 24 22.5646C24 22.1753 23.8526 21.8225 23.5948 21.5672L17.5886 15.5824C18.8536 13.9524 19.6029 11.9209 19.6029 9.70704C19.6029 4.35478 15.2057 0 9.80145 0C4.39714 0 0 4.35478 0 9.70704ZM2.10031 9.70704C2.10031 5.49822 5.55169 2.08008 9.80145 2.08008C14.0512 2.08008 17.5026 5.49822 17.5026 9.70704C17.5026 13.9159 14.0512 17.334 9.80145 17.334C5.55169 17.334 2.10031 13.9159 2.10031 9.70704Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_987_12262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.54f2140dd44ad23317151ca54f3657e3.svg";
export { ForwardRef as ReactComponent };